module.exports = __webpack_public_path__ + "static/media/COS_EG.3057c438.jpg";